import React from "react"
import { CalendarDatePickerSeeker, disabledBeforeToday } from '@ui-seeker/core'

import { rentalDates } from "@signals"


export default function RentalDatesMultiPicker({ ...props }) {

	return <CalendarDatePickerSeeker
		shouldDisableDate={disabledBeforeToday()}
		value={rentalDates.value}
		onChange={e => rentalDates.value = e}
		placeholder="Select rental dates"
		label="Rental dates"
		{...props}
	/>
}